// extracted by mini-css-extract-plugin
export default {"main_test":"Main_main_test__IpOjB","container":"Main_container__92uv-"};